import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-xs text-foreground-500">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400"></i>
            )}
            {item.to && index < items.length - 1 ? (
              <Link
                to={item.to}
                className="hover:text-primary-500 cursor-pointer transition-colors duration-200 whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-700 font-medium' : ''}>
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export function getHomeBreadcrumb() {
  return [{ label: '首页', to: '/' }];
}

export function getCategoryBreadcrumb(categoryName: string) {
  return [
    { label: '首页', to: '/' },
    { label: '漫画分类', to: '/category/all' },
    { label: categoryName },
  ];
}

export function getArticleBreadcrumb(categoryName: string, articleTitle: string) {
  return [
    { label: '首页', to: '/' },
    { label: categoryName, to: `/category/${categoryName === '全部' ? 'all' : categoryName}` },
    { label: articleTitle },
  ];
}

export function getAboutBreadcrumb() {
  return [
    { label: '首页', to: '/' },
    { label: '关于我们' },
  ];
}